import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles(
  theme => ({
    contactus: {
      textDecoration: "none"
    },
    login: {
      textDecoration: "none"
    },
    logout: {
      textDecoration: "none"
    },
    menuIcon: {
      "& span": {
        "&:nth-child(1)": {
          top: 15
        },
        "&:nth-child(2), &:nth-child(3)": {
          top: 20
        },
        "&:nth-child(4)": {
          top: 25
        },
        "@media (max-width: 300px)": {
          left: "inherit !important",
          marginRight: "10px"
        },
        [theme.breakpoints.up("md")]: {
          display: "none"
        },
        [theme.breakpoints.down("sm")]: {
          left: 0
        },
        background: theme.palette.common.white,
        cursor: "pointer",
        height: 1,
        margin: "0 0 0 -8px",
        position: "absolute",
        width: "60%"
      },
      cursor: "pointer",
      height: 30,
      left: 20,
      position: "relative",
      transform: "rotate(0deg)",
      transition: `${theme.transitions.duration.shorter}ms ease-in-out`,
      width: 50
    },
    menuItem: {
      "@media (max-width: 768px)": {
        padding: "0 5px 0 5px"
      }
    },
    register: {
      textDecoration: "none"
    }
  }),
  { name: "name" }
);

export default function MenuListComposition(props) {
  const classes = useStyles(props);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div>
      <Button
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        style={{ left: "-10px" }}
      >
        <div className={classes.menuIcon}>
          <span />
          <span />
          <span />
          <span />
        </div>
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: "center bottom" }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  <Link to="/contact-us" className={classes.contactus}>
                    <MenuItem className={classes.menuItem}>Contact Us</MenuItem>
                  </Link>
                  <Link to="/login" className={classes.login}>
                    <MenuItem className={classes.menuItem}>Login</MenuItem>
                  </Link>
                  <a
                    href="https://forms.office.com/r/LxvmVzs9Rm"
                    className={classes.register}
                    target="_blank"
                  >
                    <MenuItem className={classes.menuItem}>Register</MenuItem>
                  </a>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
